import Apa from './Apa';

class Launcher extends Apa {}

export default new Launcher();



// WEBPACK FOOTER //
// ./src/requests/apa/Launcher.js